<div class="busy-overlay-parent" [ngClass]="isLoading||!appState.isReady?'disabled':''">

    <div *ngIf="isLoading||!appState.isReady" class="font-weight-bold busy-overlay">
      <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading...
    </div>

    <div>
      <select name="dateDropdown" #dateDropdown [(ngModel)]="selectedDateOption" (ngModelChange)="onDateChange($event)">
        <option *ngFor="let dateOption of dateDropdownOptions" [ngValue]="dateOption">{{dateOption?.title}}</option>
      </select>
    </div>

    <div *fesListView="let filteredFileImports of importFiles">
      <table class="table table-striped table-bordered table-sm">
        <thead>
          <tr>
            <th fesSortField="id">ID</th>
            <th fesSortField="filename">File Name</th>
            <th fesSortField="tablename">Table Name</th>
            <th fesSortField="rowcount">Row Count</th>
            <th fesSortField="earliest">Earliest call/location time</th>
            <th fesSortField="latest">Latest call/location time</th>
            <th fesSortField="stage">Stage</th>
            <th fesSortField="importtime" sort="desc" default>Import Time</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <input fesFilterField="id" class="small w-100"/>
            </td>
            <td>
              <input fesFilterField="filename" class="small w-100"/>
            </td>
            <td>
              <input fesFilterField="tablename" class="small w-100"/>
            </td>
            <td>
              <input fesFilterField="rowcount" class="small w-100"/>
            </td>
            <td>
              <input fesFilterField="earliest" [transformFn]="formatImportTime" class="small w-100"/>
            </td>
            <td>
              <input fesFilterField="latest" [transformFn]="formatImportTime" class="small w-100"/>
            </td>
            <td>
              <app-filter-field-config>
                <input fesFilterField="stage" [(value)]='filterObj.stage' [mode]="initialStageFilterMode" class="small w-100"/>
              </app-filter-field-config>
            </td>
            <td>
              <input fesFilterField="importtime" [transformFn]="formatImportTime" class="small w-100"/>
            </td>
            <td></td>
          </tr>
          <tr *ngFor="let fileImport of filteredFileImports">
            <td>{{fileImport.id}}</td>
            <td>{{fileImport.filename}}</td>
            <td>{{fileImport.tablename}}</td>
            <td>{{fileImport.rowcount}}</td>
            <td>{{(fileImport.earliesttime !== null) ? (fileImport.earliesttime | date:'yyyy-MM-dd HH:mm:ss') : ""}}</td>
            <td>{{(fileImport.latesttime !== null) ? (fileImport.latesttime | date:'yyyy-MM-dd HH:mm:ss') : ""}}</td>
            <td>{{fileImport.stage}}</td>
            <td>{{fileImport.importtime|date:'yyyy-MM-dd HH:mm:ss'}}</td>
            <td class="text-center align-middle">
              <button class="btn btn-danger" (click)="deleteFile(fileImport)">Delete</button>
            </td>
          </tr>
        </tbody>

      </table>
      <div>
          <button class="btn btn-secondary" [disabled]="isLoading" (click)="load()"><i class="fa fa-redo"></i>&nbsp;Refresh</button>
      </div>
    </div>
  </div>